// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "tech.defiantapp",
    name: "Defiant",
    homepage: "https://www.defiantapp.tech/",
    image_id: "11a96ca4-3592-42ae-c781-2b7265ec9200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/defiant-wallet/id1559622756",
        android: "https://play.google.com/store/apps/details?id=ar.com.andinasmart.defiant&hl=en",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "defiantapp://",
        universal: "https://defiantapp.tech/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map